import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-corporate-support',
  templateUrl: './corporate-support.component.html',
  styleUrls: ['./corporate-support.component.scss']
})
export class CorporateSupportComponent implements OnInit {

  templates: Observable<any[]>;

  constructor(private afs: AngularFirestore) {
    this.templates = afs.collection('supportMessages').valueChanges();
  }

  ngOnInit() {
  }
  remove(key) {

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-support/corporate-support.component.ts